import { tx } from '@transifex/native';

/** What the portal showed everywhere before the company payload carried a
 *  currency. Tenants on a backend without the field keep this output. */
export const DEFAULT_CURRENCY = 'DKK';

/**
 * Formats an amount in the tenant's currency (see `useCompanyCurrency`).
 *
 * DKK keeps its long-standing bespoke " kr." suffix so Danish tenants see no
 * change; every other ISO 4217 code goes through `Intl.NumberFormat` in the
 * active Transifex locale, so a Finnish tenant on EUR reads "12,00 €".
 */
export const formatPayment = (value: number, curr: string) => {
  if (curr === DEFAULT_CURRENCY) return value.toString().concat(' kr.');
  // Transifex carries Norwegian as the non-BCP-47 tag `no_NO`; Intl needs
  // hyphens.
  const locale = (tx.getCurrentLocale() || 'en-IN').replace(/_/g, '-');
  try {
    return new Intl.NumberFormat(locale, {
      currency: curr,
      style: 'currency',
    }).format(value);
  } catch {
    // An unknown/malformed code must never surface an exception message in the
    // UI — degrade to "<amount> <code>".
    return `${value} ${curr}`;
  }
};
